<div *ngIf="ratings.length == 0">Noch keine Bewertungen vorhanden</div>
<div class="ratings" *ngIf="ratings.length > 0">
  <div class="stars-big">
    <div *ngFor="let num of [0,1,2,3,4]">
      <img src="/assets/star_yellow.png" height="164" width="164" alt="yellow star" *ngIf="overallRating() - num >= 1">
      <img src="/assets/star_half.png" height="164" width="164" alt="half yellow star" *ngIf="overallRating() - num < 1 && overallRating() - num >= 0.5">
      <img src="/assets/star_white.png" height="164" width="164" alt="gray yellow star"*ngIf="overallRating() - num <= 0">
    </div>
  </div>
  <p><strong>{{ overallRating() }} Sterne ({{ ratings.length }} Bewertungen)</strong></p>

  <div class="user-rating" *ngFor="let rating of ratings">
    <div class="meta">
      <div class="name">{{rating.username}}</div>
      <div class="date">{{rating.creationDate | date : 'dd.MM.yyyy'}}</div>
    </div>
    <div class="stars">
      <div *ngFor="let num of [0,1,2,3,4]">
        <img src="/assets/star_yellow.png" height="164" width="164" alt="yellow star" *ngIf="rating.stars - num >= 1">
        <img src="/assets/star_half.png" height="164" width="164" alt="half yellow star" *ngIf="rating.stars - num < 1 && rating.stars - num >= 0.5">
        <img src="/assets/star_white.png" height="164" width="164" alt="gray yellow star"*ngIf="rating.stars - num <= 0">
      </div>
    </div>
    <div class="text">{{ rating.text }}</div>
    <hr>
  </div>
</div>
